<template>
    <div class="container">
        <div class="container_body">
            <header-component :status="true"></header-component>
            <div class="products_Banner">
                <img :src="BannerUrl" alt="" srcset="">
            </div>
            <div class="content w_100 box_size">
                <div class="content_tabs">
                    <el-tabs v-model="activeName" @tab-click="handleClick" class="contents-el-tabs">
                        <el-tab-pane label="全部" name="/solutionsIndex"></el-tab-pane>
                        <el-tab-pane label="产品溯源" name="/solutionsSy"></el-tab-pane>
                        <el-tab-pane label="网络控价" name="/solutionsKj"></el-tab-pane>
                        <el-tab-pane label="新媒体营销" name="/solutionsXmt"></el-tab-pane>
                    </el-tabs>
                </div>
                <div class="tabsList_body ">
                    <div class="tabsList displayBetweenCenterwrap" v-if="tableData.length > 0">
                        <div class="items" v-for="(items, index) in tableData" :key="index" @click="onClick(items)">
                            <div class="BJ_images">
                                <img :src="items.bj_url" />
                            </div>
                            <div class="plr20 wk_product items_items displaycolumnAroundCenter">
                                <h3>
                                    <a href="javascript:void(0)" style="font-weight: normal;color: #fff;font-size: 16px;">{{ items.name
                                    }}</a>
                                </h3>
                                <p style="color: #fff;font-size: 13px;line-height: 30px;text-align: justify;">{{ items.message }}</p>
                                <h3>
                                    <a href="javascript:void(0)" style="font-weight: normal;color: #fff;font-size: 16px;">{{ items.dateName + items.date }}</a>
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="pagination w_100  mtb20 t_center" v-if="tableData.length > 0">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize"
                            layout="total, prev, pager, next" :total="total" background>
                        </el-pagination>
                    </div>
                </div>
            </div>
            <footerComponent></footerComponent>
        </div>
    </div>
</template>
<script>
import headerComponent from '../../components/comFrom/Header.vue'
import footerComponent from '../../components/comFrom/footer.vue'
import parmasData from '../../public/static/solutions.json'
export default {
    name: 'products',
    data() {
        return {
            BannerUrl: 'http://www.entfly.com/template/jiatian_jiaohu/images/bn6.jpg',
            activeName: '/solutionsKj',
            currentPage: 1, //当前页
            total: 0, //总条数
            list: [], //后台返回的所有结果
            tableData: [], //当前页码的表格数据
            pageSize: 10, //当前页容量
            pageSizes: [10, 20, 30, 40, 50],
        }
    },
    components: {
        headerComponent,
        footerComponent
    },
    mounted() {
        console.log(parmasData, 'parmasData')
        this.list = parmasData.data.Kj.list;    //总数组
        this.total = parmasData.data.Kj.total;      //总条数
        this.BannerUrl = parmasData.data.Kj.background;
        this.getList()
    },
    methods: {
        handleClick(tab, event) {
            this.activeName = tab._props.name;
            this.$router.push({ path: tab._props.name, query: { name: 'solutions'} })
        },
        onClick(items){
            this.$router.push({ path: items.path,query: { name: 'kj',data: JSON.stringify({ title: items.name, date: items.date, admin: 'admin', Count:items.count, num: items.num }),currentIndex:items.currentIndex  }})
        },
        //切换每页条数容量
        handleSizeChange(val) {
            this.currentPage = this.currentPage + 1;
            console.log(this.list, this.total, this.currentPage)
            this.getList();
        },
        //切换当前页
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },
        //获取表格数据
        getList() {
            // getList().then((res) => {
            this.list = this.list;    //总数组
            this.total = this.total;      //总条数
            this.tableData = this.getNeedArr(this.list, this.pageSize)[this.currentPage - 1]  //当前页的表格数据
            // });
        },
        // 前端处理分页
        getNeedArr(array, size) {       //获取所需指定长度分割的数组;参数1为用于分割的总数组,参数2为分割数组后每个小数组的长度
            const length = array.length;
            //判断不是数组，或者size没有设置，size小于1，就返回空数组
            if (!length || !size || size < 1) {
                return [];
            }

            let index = 0; //用来表示切割元素的范围start
            let resIndex = 0; //用来递增表示输出数组的下标

            //根据length和size算出输出数组的长度，并且创建它。
            let result = new Array(Math.ceil(length / size));
            //进行循环
            while (index < length) {
                //循环过程中设置result[0]和result[1]的值。该值根据array.slice切割得到。
                result[resIndex++] = array.slice(index, (index += size));
            }
            //输出到新数组
            return result;
        },
    }
}
</script>
<style scoped>
.container {
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    flex-direction: column;
    overflow: hidden;
}

.container_body {
    width: 100%;
    height: auto;
    overflow-y: scroll;
}

.products_Banner {
    width: 100%;
    min-width: 1180px;
    height: 300px;
    overflow: hidden;
    margin-top: 60px;
}

.products_Banner img {
    width: 100%;
    height: 100%;
}


.content_tabs {
    width: 100%;
    height: 65px;
    background: url(http://www.entfly.com/template/jiatian_jiaohu/images//about_line.jpg) repeat-x left bottom;
    overflow: hidden;
}

.contents-el-tabs {
    width: 500px;
    height: 65px;
    line-height: 65px;
    margin: 0 auto;
    font-size: 16px;
}

.tabsList_body {
    width: 1190px;
    margin: 0 auto;
}

.tabsList {
    width: 100%;
}

.tabsList_body .tabsList .items {
    background-size: cover;
    width: 360px;
    height: 262px;
    background: #f3f0ed;
    margin: 15px;
    position: relative;
    overflow: hidden;
}

.BJ_images {
    width: 100%;
    height: 262px;
}

.tabsList .items .BJ_images img {
    width: 100%;
    height: 262px;
}

.wk_product {
    width: 100%;
    height: 262px;
    position: absolute;
    text-align: center;
    background: url(http://www.entfly.com/template/jiatian_jiaohu/images//tmbg.png) repeat;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    left: 0px;
    top: -262px;
}
.items:hover .items_items{
    top: 0;
    color: #fff;
}
.product_SFTop {
    left: 0px;
    top: -107%;
}

.product_SFBottom {
    left: 0px;
    top: 100%;
}

.product_SFLeft {
    top: 0px;
    left: -100%;
}

.product_SFRight {
    top: 0px;
    left: 100%;
}

.product_STop {
    top: 0px;
}

.product_SLeft {
    left: 0px;
}
</style>
<style>
.el-tabs__nav-wrap::after {
    background: transparent !important;
}

.el-tabs__item {
    font-size: 16px !important;
}

.el-tabs__item.is-active {
    color: #DE262E !important;
}

.el-tabs__active-bar {
    background-color: #DE262E !important;
}

.el-tabs__item:hover {
    color: #DE262E !important;
}</style>